import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/pages/Hello.vue'

import ContestDetail from '../pages/contestDetail'
import Contest from'@/pages/contest.vue'
import Order2 from'@/pages/order2.vue'
import Cancelorder2 from'@/pages/cancelorder2.vue'
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'hello',
      component: Hello
    }, {
      path: '/contest',
      name: 'contest',
      component: Contest,
    },{
      path: '/contest/:id',
      name: 'contestDetail',
      component: ContestDetail,
    },
    {
      path: '/order2',
      name: 'order2',
      component: Order2,
    },
    {
      path: '/cancelorder2',
      name: 'cancelorder2',
      component: Cancelorder2,
    },
  ]
})
